import { render, staticRenderFns } from "./ProofreadingAiCancelDialog.vue?vue&type=template&id=7f2a2111&scoped=true"
import script from "./ProofreadingAiCancelDialog.vue?vue&type=script&lang=ts"
export * from "./ProofreadingAiCancelDialog.vue?vue&type=script&lang=ts"
import style0 from "./ProofreadingAiCancelDialog.vue?vue&type=style&index=0&id=7f2a2111&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f2a2111",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f2a2111')) {
      api.createRecord('7f2a2111', component.options)
    } else {
      api.reload('7f2a2111', component.options)
    }
    module.hot.accept("./ProofreadingAiCancelDialog.vue?vue&type=template&id=7f2a2111&scoped=true", function () {
      api.rerender('7f2a2111', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ui/dialogs/ProofreadingAiCancelDialog.vue"
export default component.exports